<template>
  <div class="toplevel-container" id="toplevel">
    <Topbar />
    <div class="main-content" @contextmenu.prevent>
      <div class="menu-backdrop" v-if="$root.backdrop" @click="stopEdit"></div>
      <Sidebar />
      <router-view class="main-panel" style="width: 100%" />
      <router-view class="split-panel" name="split" />
    </div>
  </div>
</template>

<style scoped>
.toplevel-container {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-image: url("/public/paprotki1.png");
  background-size: cover;
}
.menu-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  background: var(--bg-color-hover);
}
.main-content {
  position: relative;
  display: flex;
  flex: auto;
  overflow-y: auto;
  background-color: var(--bg-color-main);
}
.main-panel {
  position: relative;
  overflow-x: auto;
  flex: auto;
  min-width: 300px;
}
.split-panel {
  flex: 1 1 0;
  border-left: 2px solid grey;
  background: var(--sidebar-bg-color);
}
</style>

<script>
// UGH this seems important, probably to initialize something
import { getItem } from "@/reactive-cache";
import Sidebar from "../components/Sidebar.vue";
import Topbar from "../components/Topbar.vue";

export default {
  components: {
    Topbar,
    Sidebar,
  },
  computed: {},
  methods: {
    stopEdit() {
      if (this.$root.editedCard) {
        this.$root.editedCard.edited = false;
        this.$root.backdrop = false;
      }
    },
  },
};
</script>
